import React, { useState, useEffect } from "react";
import "../Styles/Workstation.css";
import axios from "axios";
import { showToast } from './Toast';
import { getUserDetails } from "../Utility/AsyncStorage";
import { Tooltip } from 'react-tooltip'
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'

function WorkGroup() {
  var userDetails = getUserDetails();

  const [globalWg, setGlobalWg] = useState(undefined);
  const [isFormVisible, setFormVisible] = useState(false);
  const [isDeleteVisible, setDeleteVisible] = useState(false);
  const [isassignVisible, setAssignVisible] = useState(false);
  const [isAlreadyAssignVisible, setAlreadyAssignVisible] = useState(false); //variable to pop up already assigned list
  const [assginedList, setAssignedList] = useState([]); //list for ws already assigned for WG
  const [dropDownListOfWs, setdropDownListOfWs] = useState([]); //list for DD to show ws for assign to WG
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [isPickUpVisible, setPickUpVisible] = useState(false);

  const [parts, setParts] = useState([]);
  const [formData, setFormData] = useState({});

  const workGroupListData = async () => {
    console.log("workGroupListData");
    try {
      let url = process.env.REACT_APP_BASE_URL + "/wg/listOfWg";
      let body = {
        comp_num: userDetails.comp_num,
      };
      console.log("body login", body);
      await axios
        .post(url, body, {
          headers: {
            authorization: `${userDetails.access_token}`,
          },
        })
        .then((response) => {
          if (response.status === 200) {
            if (response.data.statusCode === 0) {
              console.log("workGroupListData", response.data.list);
              setParts(response.data.list);
            } else {
              console.log("workGroupListData", response.data.msg);
            }
          }
        })
        .catch((error) => {
          console.log("workGroupListData", error);
        });
    } catch (error) {
      console.log("workGroupListData", error);
    }
  };

  const assignedWorkStationList = async (wg_num) => {
    console.log("assignedWorkStationList", wg_num);
    setAssignedList([])
    try {
      let url = process.env.REACT_APP_BASE_URL + "/wg/wgAssignList";
      let body = {
        comp_num: userDetails.comp_num,
        wg_num,
      };
      console.log("body assignedWorkStationList", body);
      await axios
        .post(url, body, {
          headers: {
            authorization: `${userDetails.access_token}`,
          },
        })
        .then((response) => {
          if (response.status === 200) {
            if (response.data.statusCode === 0) {
              console.log("assignedWorkStationList", response.data.data);
              setAssignedList(response.data.data);
            } else {
              console.log("assignedWorkStationList", response.data.msg);
            }
          }
        })
        .catch((error) => {
          console.log("assignedWorkStationList", error);
        });
    } catch (error) {
      console.log("assignedWorkStationList", error);
    }
  };

  const listOfWorkStation = async (wg_num) => {
    console.log("listOfWorkStation");
    setdropDownListOfWs([])
    setSelectedOptions([])
    try {
      let url = process.env.REACT_APP_BASE_URL + "/ws/listOfWs";
      let body = {
        comp_num: userDetails.comp_num,
        wg_num
      };
      console.log("body listOfWorkStation", body);
      await axios
        .post(url, body, {
          headers: {
            authorization: `${userDetails.access_token}`,
          },
        })
        .then((response) => {
          if (response.status === 200) {
            if (response.data.statusCode === 0) {
              console.log("listOfWorkStation", response.data.list);
              setdropDownListOfWs(response.data.list);
            } else {
              console.log("listOfWorkStation", response.data.msg);
            }
          }
        })
        .catch((error) => {
          console.log("listOfWorkStation", error);
        });
    } catch (error) {
      console.log("listOfWorkStation", error);
    }
  };

  const apiToUnassignWS = async (ws_nums) => {
    try {
      let url = process.env.REACT_APP_BASE_URL + "/wg/wsAssignCruds";
      let body = {
        comp_num: userDetails.comp_num,
        wg_num: String(globalWg),
        is_active: "N",
        ws_nums: String(ws_nums),
      };
      await axios
        .post(url, body, {
          headers: {
            authorization: `${userDetails.access_token}`,
          },
        })
        .then((response) => {
          if (response.status === 200) {
            if (response.data.statusCode === 0) {
              assignedWorkStationList(globalWg);
              setFormVisible(false);
            } else {
              console.log("apiToUnassignWS", response.data.msg);
              setFormVisible(false);
            }
          }
        })
        .catch((error) => {
          console.log("apiToUnassignWS", error);
        });
    } catch (error) {
      console.log("apiToUnassignWS", error);
    }
    setFormVisible(false);
    setFormData({});
    setGlobalWg(undefined);
  };

  const apiToAssignWS = async () => {
    if (selectedOptions.length === 0) {
      showToast("Select Workstation", 3000, "red");
      return
    }
    try {
      let url = process.env.REACT_APP_BASE_URL + "/wg/wsAssignCruds";
      let body = {
        comp_num: userDetails.comp_num,
        wg_num: globalWg,
        ws_nums: selectedOptions.join(",")
      };
      await axios
        .post(url, body, {
          headers: {
            authorization: `${userDetails.access_token}`,
          },
        })
        .then((response) => {
          if (response.status === 200) {
            if (response.data.statusCode === 0) {
              assignedWorkStationList(globalWg);
              setFormVisible(false);
              workGroupListData()
            } else {
              console.log("apiToUnassignWS", response.data.msg);
              setFormVisible(false);
            }
          }
        })
        .catch((error) => {
          console.log("apiToUnassignWS", error);
        });
    } catch (error) {
      console.log("apiToUnassignWS", error);
    }
    setFormVisible(false);
    setAssignVisible(false);
    setFormData({});
    setdropDownListOfWs([]);
    setSelectedOptions([])
    setGlobalWg(undefined);
  };

  const handleChange = (fieldName, value) => {
    setFormData((prevData) => ({
      ...prevData,
      [fieldName]: value,
    }));
  };

  const handleSubmit = async () => {
    console.log("formdata", formData)
    if (Object.keys(formData).length === 0) {
      console.log("blank")
      showToast("Provide all details ", 3000, "red");
      return
    }
    try {
      let url = process.env.REACT_APP_BASE_URL + "/wg/addWg";
      let body = {
        comp_num: userDetails.comp_num,
        wg_num: formData.wg_num,
        wg_name: formData.wg_name,
        product: formData.product,
        added_by: userDetails.user_id,
      };
      console.log("handleSubmit ", body);
      await axios
        .post(url, body, {
          headers: {
            authorization: `${userDetails.access_token}`,
          },
        })
        .then((response) => {
          if (response.status === 200) {
            if (response.data.statusCode === 0) {
              workGroupListData();
              setFormVisible(false);
              setDeleteVisible(false);
            } else {
              console.log("workGroupListData", response.data.msg);
              setFormVisible(false);
            }
          }
        })
        .catch((error) => {
          console.log("workGroupListData", error);
        });
    } catch (error) {
      console.log("workGroupListData", error);
    }
    setFormVisible(false);
    setDeleteVisible(false);
    setFormData({});
  };

  const deleteWorkGroup = async () => {
    try {
      let url = process.env.REACT_APP_BASE_URL + "/wg/addWg";
      let body = {
        comp_num: userDetails.comp_num,
        wg_num: formData.wg_num,
        wg_name: formData.wg_name,
        product: formData.product,
        added_by: userDetails.user_id,
        is_active: "N",
      };
      console.log("deleteWorkGroup ", body);
      await axios
        .post(url, body, {
          headers: {
            authorization: `${userDetails.access_token}`,
          },
        })
        .then((response) => {
          if (response.status === 200) {
            if (response.data.statusCode === 0) {

              showToast("Delete workgroup sucessfully", 3000, "green");
              workGroupListData();
              setFormVisible(false);
              setDeleteVisible(false);
            } else {
              console.log("deleteWorkGroup", response.data.msg);
              setFormVisible(false);
            }
          }
        })
        .catch((error) => {
          console.log("deleteWorkGroup", error);
        });
    } catch (error) {
      console.log("deleteWorkGroup", error);
    }
    setFormVisible(false);
    setDeleteVisible(false);
    setFormData({});
  };

  const handleSelectionChange = (event) => {
    const value = event.target.value;
    setSelectedOptions(
      (prevSelected) =>
        prevSelected.includes(value)
          ? prevSelected.filter((item) => item !== value) // Remove if already selected
          : [...prevSelected, value] // Add if not selected
    );
  };

  const editCardDetails = (cardData) => {
    console.log(cardData);
    setFormVisible(true);
    setFormData(cardData);
  };

  const pickUpFromWorkstaion = async () => {
    try {
      let url = process.env.REACT_APP_BASE_URL + "/wg/updateWgDailyCount";
      let body = {
        // comp_num: userDetails.comp_num,
        wg_num: formData.wg_num,
        count: formData.count
      };
      console.log("pickUpFromWorkstaion ", body);
      await axios
        .post(url, body, {
          headers: {
            authorization: `${userDetails.access_token}`,
          },
        })
        .then((response) => {
          if (response.status === 200) {
            if (response.data.statusCode === 0) {
              setDeleteVisible(false);
            } else {
              console.log("pickUpFromWorkstaion", response.data.msg);
              setFormVisible(false);
            }
          }
        })
        .catch((error) => {
          console.log("pickUpFromWorkstaion", error);
        });
    } catch (error) {
      console.log("pickUpFromWorkstaion", error);
    }
    setFormVisible(false);
    setDeleteVisible(false);
    setFormData({});
  };

  useEffect(() => {
    workGroupListData();
  }, []);

  return (
    <div className="mainBlock">
      <div className="header">
        <div
          className="inlineHead"
          style={{ justifyContent: "space-between", alignItems: "center" }}
        >
          <h2 className="header-h2">All WorkGroups</h2>
          <div
            className="addBlock"
            onClick={() => {
              setFormVisible(true);
            }}
          >
            <h4>Add</h4>
            <i class="fa-solid fa-layer-group"></i>
          </div>

          {/* <div className='downloadBox'>
            <h4>Download</h4>
            <i class="fa-regular fa-circle-down"></i>
          </div>

          <div className="search-bar">
            <i class="fa-solid fa-magnifying-glass"></i>
            <input type="text" placeholder="Search..." className="search-input" />
          </div> */}
        </div>
      </div>

      <table className="workgroup-table">
        <thead>
          <tr
            style={{
              height: "40px",
              backgroundColor: "#f9f9f9",
              textAlign: "left",
            }}
          >
            <th style={{ borderRadius: "10px 0 0 10px", marginLeft: "10px" }}>Workgroup Name </th>
            <th>Product Name</th>
            <th style={{ textAlign: "center" }}>Target</th>
            <th style={{ textAlign: "center" }}>Workstation Count</th>
            <th style={{ borderRadius: "0 10px 10px 0", textAlign: "center" }}>
              Action
            </th>
          </tr>
        </thead>
        {Object.keys(parts).length === 0 ?
          <tr>
            {Array.from({ length: 5 }).map((_, index) => (
              <td key={index}>
                <Skeleton count={10} />
              </td>
            ))}
          </tr>
          :
          <tbody>
            {parts.map((item, index) => (
              <tr key={index}>
                <td>{item.wg_name ?? 0}</td>
                <td>{item.product}</td>
                <td style={{ textAlign: "center" }}>{item.line_target}</td>
                <td style={{ textAlign: "center" }}>{item.ws_nums.length}</td>
                <td style={{ padding: "8px", textAlign: "center" }}>
                  <i
                    data-tooltip-id="my-tooltip"
                    data-tooltip-content="Edit"
                    style={{ margin: "5px" }}
                    class="fa-regular fa-pen-to-square"
                    onClick={() => editCardDetails(item)} //edit
                  ></i>
                  <i
                    data-tooltip-id="my-tooltip"
                    data-tooltip-content="List"
                    style={{ margin: "5px" }}
                    class="fa-solid fa-list"
                    onClick={() => {
                      setAlreadyAssignVisible(true);
                      setGlobalWg(item.wg_num);
                      assignedWorkStationList(item.wg_num); //To see already work station list
                    }}
                  ></i>
                  <i
                    data-tooltip-id="my-tooltip"
                    data-tooltip-content="Assign"
                    style={{ margin: "5px" }}
                    class="fa-regular fa-share-from-square"
                    onClick={() => {
                      setAssignVisible(true);
                      setGlobalWg(item.wg_num);
                      setdropDownListOfWs([])
                      setSelectedOptions([])
                      listOfWorkStation(item.wg_num);
                    }} //To assign new work station to via dropdown
                  ></i>
                  <i
                    data-tooltip-id="my-tooltip"
                    data-tooltip-content="Delete"
                    style={{ margin: "5px" }}
                    class="fa-regular fa-trash-can"
                    onClick={() => {
                      setDeleteVisible(true);
                      setFormData({ wg_num: item.wg_num }); //delete work group
                    }}
                  ></i>
                  <i
                    data-tooltip-id="my-tooltip"
                    data-tooltip-content="Pickup"
                    style={{ margin: "5px" }}
                    class="fa-solid fa-truck-fast"
                    onClick={() => {
                      setPickUpVisible(true);
                      setFormData({ wg_num: item.wg_num });
                    }}
                  ></i>
                  <Tooltip id="my-tooltip" />
                </td>
              </tr>
            ))}
          </tbody>
        }
      </table>

      {isFormVisible && (
        <div className="overlay">
          <div className="form-box">
            <h2>
              {formData.hasOwnProperty("wg_num")
                ? "Edit Work Group"
                : "Add Work Group"}
            </h2>
            <div>
              <div className="input-group">
                <label htmlFor="wg_name">Work Group Name</label>
                <input
                  type="text"
                  id="wg_name"
                  name="wg_name"
                  value={formData.wg_name}
                  onChange={(e) => handleChange("wg_name", e.target.value)}
                />
              </div>
              <div className="input-group">
                <label htmlFor="product">Product Name</label>
                <input
                  type="text"
                  id="product"
                  name="product"
                  value={formData.product}
                  onChange={(e) => handleChange("product", e.target.value)}
                />
              </div>
              <div style={{ justifyContent: "flex-end" }} className="inline">
                <div
                  className="submit-button"
                  onClick={() => {
                    setGlobalWg(undefined);
                    setFormVisible(false);
                    setFormData({});
                  }}
                >
                  Back
                </div>
                <div className="submit-button" onClick={handleSubmit}>
                  Submit
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {isassignVisible && (
        <div className="overlay">
          <div className="form-box">

            <h2>Assign workstations</h2>
            <label htmlFor="multi-select">Select Workspaces</label>
            <select
              id="multi-select"
              multiple
              value={selectedOptions}
              onChange={handleSelectionChange}
            >
              {dropDownListOfWs.map((option) => (
                <option key={option.ws_num} value={option.ws_num}>
                  {option.ws_name}
                </option>
              ))}
            </select>
            <div>
              <h2 style={{ marginTop: "5px" }}>Selected Workspaces</h2>
              {selectedOptions.length > 0 ? (
                <ul style={{
                  display: "flex", flexDirection: "row", flexWrap: "wrap", gap: "10px"
                }}>
                  {selectedOptions.map((selected) => {
                    const workspace = dropDownListOfWs.find(
                      (opt) => opt.ws_num === Number(selected)
                    );
                    return <li className="slectedItem" key={selected}>{workspace.ws_name}</li>;
                  })}
                </ul>
              ) : (
                <p className="select-h2">No workspaces selected</p>
              )}
            </div>

            <div className="inline" style={{ justifyContent: "flex-end", alignItems: 'center' }}>
              <div
                className="submit-button"
                onClick={() => {
                  setGlobalWg(undefined);
                  setAssignVisible(false);
                  setFormData({});
                  setdropDownListOfWs([]);
                  setSelectedOptions([])
                }}
              >
                Close
              </div>
              <div
                className="submit-button"
                onClick={() => {
                  apiToAssignWS()            //api to unassign ws
                }}
              >
                Submit
              </div>
            </div>
          </div>
        </div>
      )}

      {isAlreadyAssignVisible && (
        <div className="overlay">
          <div className="form-box">
            <h2>Assign Workstations list</h2>
            <div>
              <table className='work-table'>
                <thead style={{ borderRadius: "10px", backgroundColor: "#ddd", position: "sticky", top: 0, zIndex: 1 }}>
                  <tr>
                    <th style={{ padding: "8px", borderRadius: "10px 0 0 10px" }}>
                      Workstation Name
                    </th>
                    <th style={{ padding: "8px", borderRadius: "0 10px 10px 0" }}>
                      Action
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {assginedList.map((item, index) => (
                    <tr key={index}>
                      <td style={{ padding: "8px" }}>
                        {item.ws_name}
                      </td>
                      <td style={{ padding: "8px" }}>
                        <i class="fa-regular fa-trash-can" onClick={() => apiToUnassignWS(item.ws_num)} ></i> {/*api to unassign ws */}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div style={{ justifyContent: "flex-end" }} className="inline">
                <div
                  className="submit-button"
                  onClick={() => {
                    setGlobalWg(undefined);
                    setAlreadyAssignVisible(false);
                    setFormData({});
                  }}
                >
                  Close
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {isDeleteVisible && (
        <div className="overlay">
          <div className="form-box">
            <h2>Do you want to delete workgroup ?</h2>
            {/* <p>Do you accept?</p> */}
            <hr></hr>
            <div>
              <div style={{ justifyContent: "flex-end" }} className="inline">
                <div
                  className="submit-button"
                  onClick={() => {
                    setDeleteVisible(false);
                    setFormData({});
                  }}
                >
                  No
                </div>
                <div
                  className="submit-button"
                  onClick={() => {
                    deleteWorkGroup();
                  }}
                >
                  Yes
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {isPickUpVisible && (
        <div className="overlay">
          <div className="form-box">
            <h2>
              {formData.hasOwnProperty("ws_num")
                ? "Pickup counts"
                : "Add Work Station"}
            </h2>
            <div>
              <div className="input-group">
                <label htmlFor="count">Bag pickup Counts</label>
                <input
                  type="number"
                  id="count"
                  name="count"
                  value={formData.count}
                  onChange={(e) => handleChange("count", e.target.value)}
                />
              </div>
              <div style={{ justifyContent: "flex-end" }} className="inline">
                <div
                  className="submit-button"
                  onClick={() => {
                    setPickUpVisible(false);
                  }}
                >
                  Back
                </div>
                <div className="submit-button" onClick={pickUpFromWorkstaion}>
                  Submit
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default WorkGroup;
